import request from '@/utils/request'

// 查询行业列表
export function listIndustry(query) {
  return request({
    url: '/shop/industry/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}
